<template>
<div>
  <el-row class="title-bar" type="flex" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <div>
      <w-perf-analysis-time-info v-if="!operationFlag" v-show="dataType !== 'USER_CONNNECTION_INFO'" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
      <w-perf-analysis-time-info v-if="!operationFlag" v-show="dataType === 'USER_CONNNECTION_INFO'" fixed-time-type="current" @reload="onCurrentDataReLoad" />
    </div>
    <div>
      <el-select class="mr-r4" style="width:150px" v-model="dataType" @change="onDataTypechange">
        <el-option v-for="item in dataTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <w-header-search-button v-show="dataType !== 'RAC'" @click="onShowSearchToolButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <!-- DB 사용자 -->
  <el-table-wrapper v-show="dataType === 'DB_USER'" v-loading="isLoading.dbUser" :data="tableData.dbUser" :columns="columns.dbUser" :show-custom-header="true" :show-search-tool="showSearchTool.dbUser" :pagination="true" :column-default="columnDefault">
  </el-table-wrapper>
  <!-- DB 파라미터 -->
  <el-table-wrapper v-show="dataType === 'DB_PARAMETER'" v-loading="isLoading.dbParameter" :data="tableData.dbParameter" :columns="columns.dbParameter" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.dbParameter">
  </el-table-wrapper>
  <!--사용자 접속 정보 -->
  <el-table-wrapper v-show="dataType === 'USER_CONNNECTION_INFO'" v-loading="isLoading.userConnectionInfo" :data="tableData.userConnectionInfo" :columns="columns.userConnectionInfo" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.userConnectionInfo"
    style="width:100%;">
    <template slot-scope="scope" slot="state-slot">
        <span :class="$style['table-column-state-success']" v-if="scope.row['RETURNCODE'] === 0">정상</span>
        <span :class="$style['table-column-state-failure']" v-else>비정상</span>
      </template>
  </el-table-wrapper>
  <!-- 데이터파일 입출력 -->
  <el-table-wrapper v-show="dataType === 'DATAFILE_IO'" v-loading="isLoading.dataFileIO" :data="tableData.dataFileIO" :columns="columns.dataFileIO" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.dataFileIO">
    <template slot-scope="scope" slot="day-slot">
        <span v-html="valueDayFormatter(scope.row)"></span>
      </template>
    <template slot-scope="scope" slot="week-slot">
        <span v-html="valueWeekFormatter(scope.row)"></span>
      </template>
    <template slot-scope="scope" slot="month-slot">
        <span v-html="valueWeekFormatter(scope.row)"></span>
      </template>
  </el-table-wrapper>
  <!-- 백업 -->
  <el-table-wrapper v-show="dataType === 'BACKUP'" v-loading="isLoading.backup" :data="tableData.backup" :columns="columns.backup" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.backup">
  </el-table-wrapper>
  <!-- ASM -->
  <el-table-wrapper v-show="dataType === 'ASM'" v-loading="isLoading.asm" :data="tableData.asm" :columns="columns.asm" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.asm">
    <template slot-scope="scope" slot="userate-slot">
        <el-progress v-if="scope.row['OR_ASM_DISK_GROUP/ASM_DISK_GROUP_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['OR_ASM_DISK_GROUP/ASM_DISK_GROUP_USERATE'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
  </el-table-wrapper>
  <!-- RAC -->
  <w-oracle-rac ref="rac" v-show="dataType === 'RAC'"/>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { columnDefault } from '@/constants/table';
import { convertValuByUnit } from '@/utils/number';
import { analysisTimeType } from '@/constants/performance';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';

import WOracleRac from './OracleRac';

export default {
  name: 'WOraclePlusTable',
  mixins: [AnalysisTableMixin],
  components: {
    WOracleRac,
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      // TODO: RAC, ASM 스냅샷 정보 미개발로 인해 숨김처리, 빅데이터 연동 후 주석 해제 필요
      dataType: 'DB_USER',
      dataTypeList: [
        { label: 'DB유저', value: 'DB_USER' },
        { label: 'DB파라미터', value: 'DB_PARAMETER' },
        { label: '사용자접속정보', value: 'USER_CONNNECTION_INFO' },
        { label: 'DataFile I/O', value: 'DATAFILE_IO' },
        { label: 'Backup', value: 'BACKUP' },
        // { label: 'RAC', value: 'RAC' },
        // { label: 'ASM', value: 'ASM' },
      ],
      checkDatetime: null,
      columnDefault,
      showSearchTool: {
        dbUser: false,
        dbParameter: false,
        userConnectionInfo: false,
        dataFileIO: false,
        backup: false,
        asm: false,
      },
      isLoading: {
        dbUser: false,
        dbParameter: false,
        userConnectionInfo: false,
        dataFileIO: false,
        backup: false,
        asm: false,
      },
      tableData: {
        dbUser: [],
        dbParameter: [],
        userConnectionInfo: [],
        dataFileIO: [],
        bakup: [],
        asm: [],
      },
      columns: {
        dbUser: [
          {
            prop: 'USERNAME',
            label: '사용자',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'DEFAULT_TABLESPACE',
            label: '디폴트 테이블 공간',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'TEMPORARY_TABLESPACE',
            label: '임시 테이블 공간',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'CREATED',
            label: '생성일시',
            sortable: true,
            searchable: true,
            searchType: 'date',
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'PROFILE',
            label: '프로파일',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
        ],
        dbParameter: [
          {
            prop: 'NUM',
            label: '번호',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'NAME',
            label: '파라미터 명',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'TYPE',
            label: '타입',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'VALUE',
            label: '결과 값',
            sortable: true,
            formatter: this.resultValueFormatter,
          },
          {
            prop: 'ISDEFAULT',
            label: 'Isdefault',
            sortable: true,
            width: 100,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ISSES_MODIFIABLE',
            label: 'Isses Modifial',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ISSYS_MODIFIABLE',
            label: 'Issys Modifial',
            sortable: true,
            width: 100,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ISMODIFIED',
            label: 'Ismodified',
            sortable: true,
            width: 100,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ISADJUSTED',
            label: 'Isadjusted',
            sortable: true,
            width: 100,
            formatter: this.getTableValueAfterCheckEmpty,
          },
        ],
        userConnectionInfo: [
          {
            prop: 'RETURNCODE',
            label: '상태',
            sortable: true,
            width: 100,
            scopedSlot: 'state-slot',
            filterMultiple: false,
            filters: [
              {
                text: '정상',
                value: 1,
              },
              {
                text: '비정상',
                value: 2,
              },
            ],
            filterMethod: this.StatusFilter,
          },
          {
            prop: 'USERNAME',
            label: '사용자',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'USERHOST',
            label: '호스트',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ACTION_NAME',
            label: '로그 On/Off',
            sortable: true,
            filterMultiple: false,
            filters: [
              {
                text: 'LOGON',
                value: 'LOGON',
              },
              {
                text: 'LOGOFF',
                value: 'LOGOFF',
              },
            ],
            filterMethod: this.logFilter,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'EXTENDED_TIMESTAMP',
            label: '수행일시',
            sortable: true,
            searchable: true,
            searchType: 'date',
            formatter: this.getTableValueAfterCheckEmpty,
          },
        ],
        dataFileIO: [
          {
            prop: 'rscKeyName',
            label: '데이터파일 정보',
            headerAlign: 'center',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            label: '데이터파일 현황',
            headerAlign: 'center',
            childColumns: [
              {
                prop: 'totalCount',
                label: '전체',
                sortable: true,
                headerAlign: 'center',
                width: 300,
                formatter: this.getTableValueAfterCheckEmpty,
              },
              {
                prop: 'writeCount',
                label: '쓰기',
                sortable: true,
                headerAlign: 'center',
                width: 300,
                formatter: this.getTableValueAfterCheckEmpty,
              },
              {
                prop: 'readCount',
                label: '읽기',
                sortable: true,
                headerAlign: 'center',
                width: 300,
                formatter: this.getTableValueAfterCheckEmpty,
              },
            ],
          },
        ],
        backup: [
          {
            prop: 'FILE',
            label: '파일',
            sortable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'FILE_NAME',
            label: '파일 이름',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'TABLESPACE_NAME',
            label: '테이블 스페이스 이름',
            sortable: true,
            searchable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'STATUS',
            label: '상태',
            sortable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'CHANGE',
            label: '변경 사항',
            sortable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'TIME',
            label: '시작 일시',
            sortable: true,
            searchable: true,
            searchType: 'date',
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
        ],
        asm: [
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_NAME',
            label: '디스크 그룹명',
            sortable: true,
            searchable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_ISMOUNT',
            label: '상태',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_DATA',
            label: '중복 유형',
            sortable: true,
            searchable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_TOTALMB',
            label: '전체 크기',
            sortable: true,
            width: 150,
            formatter: this.convertMValue,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_USEDMB',
            label: '사용량',
            sortable: true,
            width: 150,
            formatter: this.convertMValue,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_USERATE',
            label: '사용률(%)',
            sortable: true,
            width: 150,
            scopedSlot: 'userate-slot',
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_USABLEMB',
            label: '가용량',
            sortable: true,
            width: 150,
            formatter: this.convertMValue,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_FREEMB',
            label: '여유공간',
            sortable: true,
            width: 150,
            formatter: this.convertMValue,
          },
          {
            prop: 'OR_ASM_DISK_GROUP/ASM_DISK_GROUP_OFFDISK_COUNT',
            label: '오프라인 디스크 수',
            sortable: true,
            width: 150,
            formatter: this.getTableValueAfterCheckEmpty,
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.dataType === 'DB_USER') {
        this.loadDbUserData();
      } else if (this.dataType === 'DB_PARAMETER') {
        this.loadDbParameterData();
      } else if (this.dataType === 'USER_CONNNECTION_INFO') {
        this.loadUserConnectionInfoData();
      } else if (this.dataType === 'DATAFILE_IO') {
        this.loadDataFileIOData();
      } else if (this.dataType === 'BACKUP') {
        this.loadBackupData();
      } else if (this.dataType === 'ASM') {
        this.loadAsmData();
      } else if (this.dataType === 'RAC') {
        const plotDate = this.operationFlag ? (this.getDatetimeParams(new Date().getTime(), true)).startDatetime : this.plotLineDatetime;
        if (this.$refs.rac) {
          this.$refs.rac.getInstanceRscKey(this.selectedNode.obj, plotDate);
        } else {
          this.$nextTick(() => {
            this.$refs.rac.getInstanceRscKey(this.selectedNode.obj, plotDate);
          });
        }
      }
    },
    /**
     * DB 사용자 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDbUserData() {
      const params = this.getCommonParams();
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.queryId = 'DBORUserInfo';
        params.parameterMap = {
          USERNAME: '\'%\'',
        };
        this.isLoading.dbUser = true;
        databaseTableInfoAPI.getDbmsDataList(params).then((result) => {
          if (result.data.success) {
            this.tableData.dbUser = result.data.data;
          } else {
            this.failToLoadDbUser();
          }
        }).catch(() => {
          this.failToLoadDbUser();
        }).finally(() => {
          this.isLoading.dbUser = false;
        });
      } else {
        this.isLoading.dbUser = true;
        databaseTableInfoAPI.getOracleDbuserList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.dbUser = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading.dbUser = false;
        });
      }
    },
    /**
     * DB 사용자 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadDbUser() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'DB 유저', false));
    },
    /**
     * DB 파라미터 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDbParameterData() {
      const params = this.getCommonParams();
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.queryId = 'DBORParameter';
        params.parameterMap = {
          NAME: '\'%\'',
        };
        this.isLoading.dbParameter = true;
        databaseTableInfoAPI.getDbmsDataList(params).then((result) => {
          if (result.data.success) {
            this.tableData.dbParameter = result.data.data;
          } else {
            this.failToLoadDbParameter();
          }
        }).catch(() => {
          this.failToLoadDbParameter();
        }).finally(() => {
          this.isLoading.dbParameter = false;
        });
      } else {
        this.isLoading.dbParameter = true;
        databaseTableInfoAPI.getOracleParameterList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.dbParameter = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadDbParameter();
          }
        }).catch(() => {
          this.failToLoadDbParameter();
        }).finally(() => {
          this.isLoading.dbParameter = false;
        });
      }
    },
    /**
     * DB 파라미터 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadDbParameter() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'DB 파라미터', false));
    },
    /**
     * 사용자 접속 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadUserConnectionInfoData() {
      // TODO: 사용자 접속 정보 스냅샷 개발 후 시간 타입에 따라 분기하여 조회 처리 필요.
      const params = this.getCommonParams();
      this.isLoading.userConnectionInfo = true;
      databaseTableInfoAPI.getOracleUserConnInfoList(params).then((result) => {
        if (result.data.success) {
          this.tableData.userConnectionInfo = result.data.data;
        } else {
          this.failToLoadUserConnectionInfo();
        }
      }).catch(() => {
        this.failToLoadUserConnectionInfo();
      }).finally(() => {
        this.isLoading.userConnectionInfo = false;
      });
    },
    /**
     * 사용자 접속 정보 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadUserConnectionInfo() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 접속 정보', false));
    },
    /**
     * 데이터 파일 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDataFileIOData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = {
          objId: this.selectedNode.obj.objId,
        };
        this.isLoading.dataFileIO = true;
        databaseTableInfoAPI.getCurrentOracleDataFileList(params).then((result) => {
          if (result.data.success) {
            this.tableData.dataFileIO = result.data.data;
          } else {
            this.failToLoadDataFileIO();
          }
        }).catch(() => {
          this.failToLoadDataFileIO();
        }).finally(() => {
          this.isLoading.dataFileIO = false;
        });
      } else {
        const params = this.getCommonParams();
        this.isLoading.dataFileIO = true;
        databaseTableInfoAPI.getOracleDatafileList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.dataFileIO = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadDataFileIO();
          }
        }).catch(() => {
          this.failToLoadDataFileIO();
        }).finally(() => {
          this.isLoading.dataFileIO = false;
        });
      }
    },
    /**
     * 데이터 파일 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadDataFileIO() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'DataFile I/O', false));
    },
    /**
     * 백업 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadBackupData() {
      const params = this.getCommonParams();
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.queryId = 'DBORBackUpInfo';
        this.isLoading.backup = true;
        databaseTableInfoAPI.getCurrentOraclebackupList(params).then((result) => {
          if (result.data.success) {
            this.tableData.backup = result.data.data;
          } else {
            this.failToLoadBackup();
          }
        }).catch(() => {
          this.failToLoadBackup();
        }).finally(() => {
          this.isLoading.backup = false;
        });
      } else {
        this.isLoading.backup = true;
        databaseTableInfoAPI.getOraclebackupList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.backup = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadBackup();
          }
        }).catch(() => {
          this.failToLoadBackup();
        }).finally(() => {
          this.isLoading.backup = false;
        });
      }
    },
    /**
     * 백업 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadBackup() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Backup', false));
    },
    /**
     * ASM 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadAsmData() {
      const params = this.getCommonParams();
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        this.isLoading.asm = true;
        databaseTableInfoAPI.getCurrentOracleAsmList(params).then((result) => {
          if (result.data.success) {
            this.tableData.asm = result.data.data;
          } else {
            this.failToLoadAsm();
          }
        }).catch(() => {
          this.failToLoadAsm();
        }).finally(() => {
          this.isLoading.asm = false;
        });
      } else {
        this.isLoading.userConnectionInfo = true;
        databaseTableInfoAPI.getOracleasmList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.asm = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadAsm();
          }
        }).catch(() => {
          this.failToLoadAsm();
        }).finally(() => {
          this.isLoading.asm = false;
        });
      }
    },
    /**
     * AMS 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadAsm() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'ASM', false));
    },
    /**
     * 데이터 조회 시 필요한 공통 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getCommonParams() {
      return {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.operationFlag ? (this.getDatetimeParams(new Date().getTime(), true)).startDatetime : this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
    },
    /**
     * [onShowSearchToolButtonClick dataType 마다 show 하는 검색 툴 구분]
     * @author {name}
     */
    onShowSearchToolButtonClick() {
      if (this.dataType === 'DB_USER') {
        this.showSearchTool.dbUser = !this.showSearchTool.dbUser;
      } else if (this.dataType === 'DB_PARAMETER') {
        this.showSearchTool.dbParameter = !this.showSearchTool.dbParameter;
      } else if (this.dataType === 'USER_CONNNECTION_INFO') {
        this.showSearchTool.userConnectionInfo = !this.showSearchTool.userConnectionInfo;
      } else if (this.dataType === 'DATAFILE_IO') {
        this.showSearchTool.dataFileIO = !this.showSearchTool.dataFileIO;
      } else if (this.dataType === 'BACKUP') {
        this.showSearchTool.backup = !this.showSearchTool.backup;
      } else if (this.dataType === 'ASM') {
        this.showSearchTool.asm = !this.showSearchTool.asm;
      }
    },
    /**
     * 데이터 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onDataTypechange() {
      this.loadData();
    },
    /**
     * [resultValueFormatter DB파라미터 테이블 결과값 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    resultValueFormatter(row) {
      return this.formatterFileEmpty(row, 'resultValue');
    },
    /**
     * [formatterFileEmpty 빈 값이 있으면 -로 출력]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @param  {[type]} col [description]
     * @return {[type]}     [description]
     */
    formatterFileEmpty(row, col) {
      if (isNil(row[col]) || isEmpty(row[col])) {
        return EMPTY_TEXT;
      }
      return row[col];
    },
    /**
     * [StatusFilter 사용자 접속정보 상태에 대한 필터링]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     */
    StatusFilter(value, row) {
      if (value === 1) {
        return row.RETURNCODE === 0;
      }
      return row.RETURNCODE !== 0;
    },
    /**
     * [logFilter 사용자 접속정보 logon/off에 대한 필터링]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     * @return {[type]}       [description]
     */
    logFilter(value, row) {
      return row.log === value;
    },
    /**
     * [convertStockRendererForGrid 기준값과 비교값을 이용하여 증감대비 값을 계산한다.]
     * @author {name}
     * @param  {[type]} curValue      [비교 주체가 되는 현재값]
     * @param  {[type]} rendererValue [현재값에 견주어 계산하고자 하는 값]
     * @return {[type]}               [description]
     */
    convertStockRendererForGrid(curValue, rendererValue) {
      let resultValue;
      let valueCheck = rendererValue;

      if (isNil(valueCheck)) {
        valueCheck = -1;
      } else if (!isNumber(valueCheck)) {
        valueCheck = Number(valueCheck);
      }
      if (curValue < 0 || valueCheck < 0) {
        return EMPTY_TEXT;
      }

      const valueDelta = curValue - valueCheck;
      let deltaValue = Math.abs(valueDelta.toFixed(1));
      const deltaRate = (Number(valueDelta.toFixed(1)) / Number(valueCheck).toFixed(1)) * 100;
      const overchange = Math.abs(deltaRate) > 20;

      if (valueDelta === 0) {
        resultValue = deltaValue;
      } else {
        deltaValue = deltaValue.toFixed(0);
        if (deltaValue === '0') {
          resultValue = deltaValue;
        } else if (overchange) {
          if (valueDelta > 0) {
            /* TODO 아이콘 삽입 필요. */
            resultValue = `<span class="row-icon icon-stock-up2"></span>${deltaValue}`;
          } else if (valueDelta < 0) {
            resultValue = `<span class="row-icon icon-stock-down2"></span>${deltaValue}`;
          }
        } else if (!overchange) {
          if (valueDelta > 0) {
            resultValue = `<span class="row-icon icon-stock-up"></span>${deltaValue}`;
          } else if (valueDelta < 0) {
            resultValue = `<span class="row-icon icon-stock-down"></span>${deltaValue}`;
          }
        }
      }
      return resultValue;
    },
    /**
     * [valueDayFormatter 전일 대비 컬럼]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    valueDayFormatter(row) {
      return this.convertStockRendererForGrid(row.valueCurrent, row.valueDay);
    },
    /**
     * [valueWeekFormatter 전주 대비 컬럼]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    valueWeekFormatter(row) {
      return this.convertStockRendererForGrid(row.valueCurrent, row.valueWeek);
    },
    /**
     * [valueMonthFormatter 전월 대비 컬럼]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    valueMonthFormatter(row) {
      return this.convertStockRendererForGrid(row.valueCurrent, row.valueMonth);
    },
    convertMValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'M', true);
    },
    /**
     * [getPercentage 프로그레스바 * 100 처리]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getPercentage(value) {
      return isNil(value) ? 0 : value * 100;
    },
    onLoadOracleRac() {
      this.$emit('');
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style module>
.table-column-state-success {
  color: #5a9ee4;
}

.table-column-state-failure {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/OraclePlus/index.vue